<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple"></ngx-spinner>
<app-header></app-header>

<br>
  
    <div class="col-md-1 search_input" style="border: 100px;">
      <button class="btn btn-dark offset-md-9" (click)="downloadAllPartsDataCSV()">
        <i class="fa fa-download" aria-hidden="true"></i>&nbsp;&nbsp;Export Parts Data</button>
    </div>

    <br>
  
    <div class="col-md-1 search_input" style="border: 100px;">
      <button class="btn btn-dark offset-md-9" (click)="downloadApprovedPackageCSV()">
        <i class="fa fa-download" aria-hidden="true"></i>&nbsp;&nbsp;Export Package Data</button>
    </div>

    <br>
    <div class="col-md-1 search_input" style="border: 100px;">
      <button class="btn btn-dark offset-md-9" (click)="downloadPartLevelMasterCSV()">
        <i class="fa fa-download" aria-hidden="true"></i>&nbsp;&nbsp;Export Part Level Master</button>
    </div>
 
